import { render, staticRenderFns } from "./SelectionCardMulti.vue?vue&type=template&id=5f6f902e"
import script from "./SelectionCardMulti.vue?vue&type=script&lang=js"
export * from "./SelectionCardMulti.vue?vue&type=script&lang=js"
import style0 from "./SelectionCardMulti.vue?vue&type=style&index=0&id=5f6f902e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports